import { Link } from "react-router-dom";
import { formatINR } from "@/data/products";

export default function ProductCard({ product, index = 0 }) {
  return (
    <Link
      to={`/product/${product.slug}`}
      data-testid={`product-card-${product.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${(index % 6) * 60}ms` }}
    >
      <div className="relative overflow-hidden bg-[#F0EBE1] aspect-[4/5]">
        {/* Primary: plain product on white (clear catalog look) */}
        <img
          src={product.thumbnail || product.images.plain || product.images.hero}
          alt={product.name}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover transition-opacity duration-500 group-hover:opacity-0"
        />
        {/* Hover: lifestyle model shot (or hero creative for pendants) */}
        <img
          src={product.images.lifestyle || product.images.hero || product.thumbnail}
          alt={`${product.name} — worn`}
          loading="lazy"
          className="absolute inset-0 w-full h-full object-cover opacity-0 transition-opacity duration-700 group-hover:opacity-100"
        />
        {product.isNew && (
          <span
            data-testid={`new-badge-${product.slug}`}
            className="absolute top-4 left-4 bg-[#FAF8F5]/90 backdrop-blur-sm text-[#2A2626] text-[10px] uppercase tracking-[0.24em] px-3 py-1 z-10"
          >
            New
          </span>
        )}
        {product.videoId && (
          <span
            data-testid={`video-badge-${product.slug}`}
            className="absolute top-4 right-4 bg-[#2A2626]/85 text-[#FAF8F5] text-[9px] uppercase tracking-[0.22em] px-2.5 py-1 z-10 flex items-center gap-1"
          >
            <span className="w-1.5 h-1.5 bg-[#FAF8F5] rounded-full" /> Video
          </span>
        )}
      </div>
      <div className="mt-4 md:mt-5 flex items-start justify-between gap-3 px-0.5">
        <div className="min-w-0">
          <h3 className="font-serif text-[17px] md:text-[19px] leading-tight text-[#2A2626] truncate">
            {product.name}
          </h3>
          <p className="mt-1 text-[10px] md:text-[11px] uppercase tracking-[0.18em] text-[#5C564F] truncate">
            {product.gemstones.slice(0, 2).join(" · ")}
          </p>
        </div>
        <p className="font-sans text-[13px] md:text-sm text-[#2A2626] shrink-0 pt-1">
          {formatINR(product.price)}
        </p>
      </div>
    </Link>
  );
}
